export const iconFontAwesomeMoneyGuaraniSign = (
	<i className="fa-solid fa-guarani-sign"></i>
);
